import { ClockCircleOutlined } from '@ant-design/icons'
import { Button, Popover } from 'antd'
import React from 'react'
import { compose, withHandlers, withState } from 'recompose'

import StartTimeForm from './StartTimeForm'

type WithPopoverVisibleState = {
  popoverVisible: boolean
  setPopoverVisible(value: boolean): void
}

type WithPopoverHandlersProps = {
  hidePopover(): void
  togglePopover(): void
}

type StartTimePopoverOuterProps = {
  defaultInterval?: number
  numberOfFlights: number
  onSubmit(startTime: Date, interval: number, applyFrom: number): void
}

type StartTimePopoverInnerProps = StartTimePopoverOuterProps &
  WithPopoverVisibleState &
  WithPopoverHandlersProps

const StartTimePopover: React.FunctionComponent<StartTimePopoverInnerProps> = ({
  defaultInterval,
  numberOfFlights,
  onSubmit,
  popoverVisible,
  setPopoverVisible,
  hidePopover,
  togglePopover,
}) => {
  const onSubmitAndHide = (startTime: Date, interval: number, applyFrom: number) => {
    const result = onSubmit(startTime, interval, applyFrom)
    hidePopover()

    return result
  }

  return (
    <Popover
      title="Batch Set Start Time"
      trigger="click"
      visible={popoverVisible}
      content={
        <StartTimeForm
          defaultInterval={defaultInterval}
          numberOfFlights={numberOfFlights}
          onSubmit={onSubmitAndHide}
          onCancel={hidePopover}
        />
      }>
      <Button icon={<ClockCircleOutlined />} onClick={togglePopover}>
        Batch Set Start Time
      </Button>
    </Popover>
  )
}

export default compose<StartTimePopoverInnerProps, StartTimePopoverOuterProps>(
  withState('popoverVisible', 'setPopoverVisible', false),
  withHandlers<WithPopoverVisibleState, WithPopoverHandlersProps>({
    hidePopover: ({ setPopoverVisible }) => () => setPopoverVisible(false),
    togglePopover: ({ popoverVisible, setPopoverVisible }) => () =>
      setPopoverVisible(!popoverVisible),
  }),
)(StartTimePopover)



// WEBPACK FOOTER //
// ./src/components/flights/StartTimePopover.tsx